import { createApp } from 'vue'
import { createPinia } from 'pinia'
import Antd from 'ant-design-vue'
import App from './App.vue'
import router from './router'
import 'ant-design-vue/dist/reset.css'
import './styles/global.css'

// Suppress ResizeObserver errors (harmless Ant Design warning)
const debounce = (fn, delay) => {
  let timeoutId
  return (...args) => {
    clearTimeout(timeoutId)
    timeoutId = setTimeout(() => fn(...args), delay)
  }
}

const originalError = console.error
console.error = debounce((...args) => {
  if (
    typeof args[0] === 'string' && 
    args[0].includes('ResizeObserver')
  ) {
    return
  }
  originalError(...args)
}, 100)

const app = createApp(App)

app.use(createPinia())
app.use(router)
app.use(Antd)

app.mount('#app')

